const Marionette = require('backbone.marionette');
const templates = require('../templates');
const PopupFooterActivityChildView = require('./popup_footer_activity.js');

module.exports = Marionette.CompositeView.extend({
  template: templates.popup_footer_next,
  childView: PopupFooterActivityChildView,
  childViewContainer: '.right_block .courses',
  childViewOptions(model) {
    return {
      model,
      hour: true
    };
  },
  emptyView: Marionette.ItemView.extend({
    template() {}
  })
});



// WEBPACK FOOTER //
// ./src/views/popup_footer_next.js